import { PortalLicense } from '~/shared/types/license'
import { PORTAL_PRODUCT_ROLE } from '~/shared/types/product'
import { ApiHubMeters, SWAGGERHUB_ROLE, SubscriptionAuthority } from '~/shared/types/shub'

export interface PortalStatusData {
  exists: boolean
  subdomain: string
  customDomain: string
  highestRole: SWAGGERHUB_ROLE
  availableSubdomains?: string[]
}

export enum SWAGGERHUB_PLAN_TYPE {
  FREE = 'free',
  TRIAL = 'trial',
  TEAM = 'team',
  ENTERPRISE = 'enterprise'
}

export interface SwaggerHubLicense {
  planType: SWAGGERHUB_PLAN_TYPE
}

export interface SwaggerHubUser {
  organizationRole: SWAGGERHUB_ROLE,
  highestRole: SWAGGERHUB_ROLE,
  platformAdmin?: boolean,
}

export interface PortalProductStatus {
  id: string,
  slug: string,
  role: PORTAL_PRODUCT_ROLE,
  canAccess: boolean,
  name?: string,
}

export interface ApiHubGates {
  sbFooterRemoved: boolean,
  subdomainEditingEnabled: boolean,
  customDomainEnabled: boolean,
  consumerSideOnline: boolean,
  requestAccessEnabled: boolean,
  attachmentManagerEnabled: boolean,
  ckEditorEnabled: boolean,
  privateAndHiddenProductsEnabled: boolean,
  collaborationEnabled: boolean,
  personalizationEnabled: boolean,
}

export interface ApiHubProductMeters extends ApiHubMeters {
  warningThreshold: number,
}

export interface ApiHubTemplateMeters extends ApiHubMeters {}

export interface ApiHubSeatMeters extends ApiHubMeters {}

export enum API_HUB_PLAN {
  TRIAL = 'Trial',
  FREE = 'Free',
  GOOD = 'Good',
  BETTER_DOCUMENT = 'Better - Document',
  BETTER_DESIGN = 'Better - Design',
  BETTER_TEST = 'Better - Test',
  BEST = 'Best',
}

export interface ApiHubPlan {
  name: string,
  gates: ApiHubGates,
  productMeters: ApiHubProductMeters,
  templateMeters: ApiHubTemplateMeters,
  seatMeters: ApiHubSeatMeters,
  platformManaged: boolean,
  expiresAt?: string,
  renewalDate?: string,
  gracePeriod?: string,
  subscriptionId?: string,
  subscriptionAuthority?: SubscriptionAuthority,
}

export enum RoutingOption {
  BROWSER = 'browser',
  PROXY = 'proxy',
}

export interface RoutingSettings {
  routing: RoutingOption;
  credentialsEnabled: boolean;
}

export enum APIRenderers {
  ASYNCAPI = 'ASYNCAPI',
  ELEMENTS = 'ELEMENTS',
  SWAGGER_UI = 'SWAGGER_UI'
}

export enum OpenAPIRendererState {
  SWAGGER_UI = APIRenderers.SWAGGER_UI,
  ELEMENTS = APIRenderers.ELEMENTS,
  TOGGLE = 'TOGGLE',
}

export interface PortalStatus {
  portal: {
    id: string,
    subdomain: string,
    offline: boolean,
    customDomain?: string,
    gtmKey?: string,
    name?: string,
    createdAt?: string,
  },
  product: PortalProductStatus,
  license: PortalLicense,
  plan?: ApiHubPlan,
  swaggerHubLicense: SwaggerHubLicense,
  user?: SwaggerHubUser,
  swaggerhubOrgName: string,
  swaggerhubOrgDisplayName?: string,
  swaggerhubOrgId: string,
  swaggerhubOrgCreatedAt: string,
  openapiRenderer: OpenAPIRendererState,
  routingSettings?: RoutingSettings,
  externalLoginEnabled?: boolean,
  cutoverDate?: string,
  externalAuth0OrgId?: string,
  /** Top level, only present for logged in members. Never the url or secret */
  webhookEnabled?: boolean,
}
